import { format, formatDistanceToNow } from 'date-fns'
import { Timestamp } from 'firebase/firestore'
import { FirestoreDate } from '@/types'

export function toDate(value: FirestoreDate): Date | null {
  if (!value) return null
  if (value instanceof Date) return value
  if (value instanceof Timestamp) return value.toDate()
  if (typeof value === 'string') return new Date(value)
  return null
}

export function formatDateTime(value: FirestoreDate, fallback = 'Belum ada') {
  const date = toDate(value)
  return date ? format(date, 'dd MMM yyyy, HH:mm') : fallback
}

export function formatRelativeTime(value: FirestoreDate, fallback = 'Belum ada') {
  const date = toDate(value)
  return date ? formatDistanceToNow(date, { addSuffix: true }) : fallback
}

export function formatCompactNumber(value: number | null | undefined) {
  return new Intl.NumberFormat('id-ID', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value ?? 0)
}

export function formatNumber(value: number | null | undefined) {
  return new Intl.NumberFormat('id-ID').format(value ?? 0)
}

export function formatCurrency(
  value: number | null | undefined,
  currency = 'IDR',
) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(value ?? 0)
}

export function statusTone(status: string | undefined) {
  switch (status) {
    case 'active':
    case 'published':
    case 'paid':
    case 'completed':
    case 'resolved':
    case 'enabled':
      return 'emerald'
    case 'review':
    case 'pending':
    case 'draft':
    case 'in_progress':
      return 'amber'
    case 'disabled':
    case 'inactive':
    case 'cancelled':
    case 'archived':
    case 'closed':
      return 'stone'
    case 'urgent':
    case 'blocked':
      return 'rose'
    default:
      return 'teal'
  }
}
